import React from 'react';
import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import List from '@mui/material/List';

import LinkListItem from './LinkListItem';
import mapStateToProps from './mapStateToProps';

/**
 * Навигациооный список
 * @param linkArr  Массив объектов ссылок
 */
const LinkList = (props) => {
    const { linkArr=[] } = props
    const {
        paletteWidth,
    } = useSelector(mapStateToProps)

    return (
        <Box sx={{ width: '100%', maxWidth: paletteWidth, bgcolor: 'background.paper' }}>
            <List component="nav" aria-label="main mailbox folders">
                {linkArr.map((link, i) => <LinkListItem key={i} {...link}/>)}
            </List>
        </Box>
    )
}

export default LinkList